var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2C14.25 1.58579 13.9142 1.25 13.5 1.25C13.0858 1.25 12.75 1.58579 12.75 2V4C12.75 4.41421 13.0858 4.75 13.5 4.75C13.9142 4.75 14.25 4.41421 14.25 4V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9816 14.1482L19.4601 17.412C19.037 20.0595 16.8408 22 14.2673 22H10.8046C9.81048 22 9.00459 21.1941 9.00459 20.2V13.2675C8.97047 12.8404 9.12795 12.4216 9.42782 12.142L10.4914 11.1502C10.9848 10.69 11.4595 10.1921 11.7666 9.57009C11.9767 9.14436 12.1397 8.69379 12.2516 8.22699L12.6032 6.75991C12.6713 6.47579 12.8551 6.23689 13.1062 6.10591C13.3344 5.98692 13.5985 5.96734 13.8405 6.05148L13.9477 6.08874C14.3482 6.22796 14.6526 6.57091 14.755 6.99802C14.8786 7.5136 14.9013 8.05148 14.8217 8.57714L14.3319 11.8128C14.2704 12.2186 14.5595 12.5874 14.9391 12.5874H18.769C19.5326 12.5874 20.1119 13.333 19.9816 14.1482Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.9C4 13.4029 4.40294 13 4.9 13H7.65425C7.64854 13.1039 7.64863 13.2082 7.65459 13.3125V20.2C7.65459 20.8661 7.86136 21.484 8.21421 21.9928C8.17681 21.9976 8.13869 22 8.1 22H4.9C4.40294 22 4 21.5971 4 21.1V13.9Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9C17.25 8.58579 17.5858 8.25 18 8.25H20C20.4142 8.25 20.75 8.58579 20.75 9C20.75 9.41421 20.4142 9.75 20 9.75H18C17.5858 9.75 17.25 9.41421 17.25 9Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.25C6.58579 8.25 6.25 8.58579 6.25 9C6.25 9.41421 6.58579 9.75 7 9.75H9C9.41421 9.75 9.75 9.41421 9.75 9C9.75 8.58579 9.41421 8.25 9 8.25H7Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1516 6.34817C15.8588 6.05528 15.8588 5.5804 16.1516 5.28751L17.5659 3.8733C17.8588 3.5804 18.3336 3.5804 18.6265 3.8733C18.9194 4.16619 18.9194 4.64106 18.6265 4.93396L17.2123 6.34817C16.9194 6.64106 16.4445 6.64106 16.1516 6.34817Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8477 5.28751C11.1406 5.5804 11.1406 6.05528 10.8477 6.34817C10.5548 6.64106 10.0799 6.64106 9.78705 6.34817L8.37284 4.93396C8.07995 4.64106 8.07995 4.16619 8.37284 3.8733C8.66573 3.5804 9.14061 3.5804 9.4335 3.8733L10.8477 5.28751Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike3);
export default __webpack_public_path__ + "static/media/like-3.03a90f78ca7a0c9f2c41914798997f0b.svg";
export { ForwardRef as ReactComponent };